/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPricingsGroupHealthQuery = gql`
  query GetSimulationPricingsGroupHealthQuery {
    getSimulationPricingsGroupHealth_simulation_pricings_group_health {
      effectDate 
      employerPercentShare 
      tariffStructure 
      packs {
 packCode  
}
      pricings {
 pricingLabel  
pricingNote  
idcc  
isPreSelected  
modules {
 moduleCode  
moduleLabel  
guarantees {
 guaranteeCode  
guaranteeNote  
isRecommended  
value  
valueNote  
ccnStatus  
isTitle  
} 
} 
prices {
 tariffStructureCode  
tariffStructureLabel  
details {
 code  
label  
priceValue  
priceUnit  
priceYear  
} 
} 
options {
 isPreSelected  
optionCode  
optionName  
prices {
 tariffStructureCode  
tariffStructureLabel  
details {
 code  
label  
priceValue  
priceUnit  
priceYear  
} 
} 
} 
totalPrices {
 tariffStructureCode  
withBenef  
withoutBenef  
} 
optionsSelectionMode  
}
      minimumCcnCompliantLevel 
      tariffStructures {
 value  
label  
}
      beneficiariesEnrollment 
      companyCcnHasAgreement 
      error 
    }
  }
`;

export default GetSimulationPricingsGroupHealthQuery;
